export enum UserManagerType {
  NotSet = 0,
  Approver = 1,
  Interviewer = 2,
  SystemAccess = 3,
  TimeRegistration = 4,
  ApproverHourly = 5,
  ApproverPeriod = 6,
}
